import React from 'react';
import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';
import breakpoints from '../Theme/breakpoints';

interface ListItemProperties {
  height?: number;
  flexDirection?: string;
}

const ListItemContainer = styled.div<ListItemProperties>`
  display: flex;
  flex-direction: ${({ flexDirection }) => (flexDirection ?? 'row')};
  justify-content: start;
  align-items: center;
  width: 100%;
  height: ${({ height }) => (height ? `${height}px` : '225px')};
  margin-bottom: 1rem;
`;

const ListImage = styled(Skeleton)`
  height: 60px;
  width: 60px;
  margin: 0 1rem;

  @media (min-width: ${breakpoints.xssm}px) {
    height: 100px;
    width: 100px;
  }
`;

const ListText = styled(Skeleton)`
  flex: 1;
  height: 100%;
  padding-right: 0.5rem;
`;

const ListItemSkeleton = ({
  height,
  flexDirection,
}: ListItemProperties) => (
  <ListItemContainer height={height} flexDirection={flexDirection}>
    <ListImage variant="rectangular" />
    <ListText variant="rectangular" />
  </ListItemContainer>
);

export default ListItemSkeleton;
